<template>
  <div class="row">
    <div class="col">
      <ZFilterHeader
        :title="firmName"
        :isRouteHome="false"
        :isDateRange="true"
        :startDate="dashboardDateRange.startDate"
        :endDate="dashboardDateRange.endDate"
        :isFilter="false"
        @datesChanged="datesChanged"
        @refresh="refresh"
      />
    </div>
  </div>
  <div class="row pb-2">
    <div class="col">
      <ShopServiceSummary />
    </div>
  </div>
  <div class="row d-none d-md-block">
    <div class="col pt-2">
      <ZTableHeader
        :headerProps="headerProps"
        :listParams="currentParams"
        :showTitle="false"
        @search="search"
        @updateParams="updateParams"
      />
    </div>
  </div>
  <div class="row mb-2">
    <!-- <div class="col"></div> -->
    <div class="col">
      <div class="row d-flex custom-color-codes">
        <div class="col-6 col-sm-3">
          <i class="fa-solid fa-circle custom-color-green"></i>
          <span class="ms-1">Completed</span>
        </div>
        <div class="col-6 col-sm-3">
          <i class="fa-solid fa-circle custom-color-red"></i>
          <span class="ms-1">Due Date Passed</span>
        </div>
        <div class="col-6 col-sm-3">
          <i class="fa-solid fa-circle custom-color-yellow"></i>
          <span class="ms-1">In Progress</span>
        </div>
        <div class="col-6 col-sm-3">
          <i class="fa-solid fa-circle custom-color-grey"></i>
          <span class="ms-1">Not Started</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-none d-md-block">
    <div class="col overflow-scroll">
      <ZTable
        v-model="tableData"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="true"
        :columns="tableHeader"
        @sort="sortColumn"
      >
        <template #tbody="props">
          <td class="custom-column-60-center custom-view-link">
            <button class="btn btn-link" @click="viewRecord(props.row)">view</button>
          </td>
          <td>{{ props.row.adasInspection }}</td>
          <td>{{ props.row.ronumber }}</td>
          <td>
            <div class="custom-vehicle">
              <span>{{ props.row.vin }}</span>
              <span class="custom-vehicle-info">{{ setVehicle(props.row) }}</span>
            </div>
          </td>
          <td>{{ formatDate(props.row.deliveryDate) }}</td>
          <td>{{ props.row.numberSystems }}</td>
          <td>{{ props.row.numberServices }}</td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
        </template>
        <template #empty> Nothing found! </template>
      </ZTable>
    </div>
  </div>
  <div class="row d-block d-md-none">
    <div class="shop-card">
      <ZHeader
        :headerProps="headerProps"
        :listParams="currentParams"
        :isPaginated="false"
        :showTitle="false"
        @updateParams="updateParams"
        @search="search"
      />
      <div class="row m-0 dashboard-shop-card">
        <div v-if="!cardData">
          <Loader singleCard="true" />
        </div>
        <div v-if="cardData && cardData !== 'noData'" class="row">
          <div
            v-for="(item, idx) of cardData"
            :key="idx"
            class="col-12 col-sm-6 col-md-3 shop-list-container p-2"
          >
            <div class="shop-list-div p-3">
              <div class="shop-header-mobile pb-3 d-flex justify-content-between">
                <div>
                  <p class="shop-name-mobile colorPrimary text-start fw-6 fs-16 m-0">
                    {{ item.vin }}
                  </p>
                  <p class="colorPrimary text-start m-0 fs-12">{{ item.model }}</p>
                </div>
                <div>
                  <button
                    class="btn router-image-btn collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#expandDiv' + idx"
                    aria-expanded="false"
                  >
                    <span class="sd-expand"
                      >Expand <i class="fa fa-angle-down" aria-hidden="true"></i
                    ></span>
                    <span class="sd-collapse"
                      >Collapse <i class="fa fa-angle-up" aria-hidden="true"></i
                    ></span>
                  </button>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0">#Ro</p>
                  <p class="shop-service-required-mobile fs-14 colorPrimary text-start fw-b m-0">
                    {{ item.ronumber }}
                  </p>
                </div>
                <div>
                  <p class="text-start fs-12 colorPrimary m-0"># of ADAS System</p>
                  <p class="shop-service-completed-mobile text-start fs-14 colorPrimary fw-b m-0">
                    {{ item.numberSystems }}
                  </p>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0">Delivery Date</p>
                  <p class="shop-service-required-mobile fs-14 colorPrimary text-start fw-b m-0">
                    {{ formatDate(item.deliveryDate) }}
                  </p>
                </div>
                <div>
                  <p class="text-start fs-12 colorPrimary m-0"># of Required Services</p>
                  <p class="shop-service-completed-mobile text-start fs-14 colorPrimary fw-b m-0">
                    {{ item.numberServices }}
                  </p>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p
                    class="text-start colorPrimary fs-12 m-0 btn btn-link"
                    @click="viewRecord(item)"
                  >
                    View
                  </p>
                </div>
              </div>
              <!-- <div :id="'expandDiv'+idx" class="collapse row m-0 pt-3">
                <div class="col-6 p-0">
                    <p class="service-ro-title-mobile text-start fs-12 m-0">Pre-Scan</p>
                    <p class="service-ro-mobile text-start fw-b">
                      <i class="fa-solid fa-circle" :class="getServiceStatus(item)"></i>
                    </p>
                </div>
                <div class="col-6 p-0">
                    <p class="service-location-mobile text-start fs-12 m-0">In Progress Scan</p>
                    <p class="service-service-completed-mobile text-start fw-b">
                      <i class="fa-solid fa-circle" :class="getServiceStatus(item)"></i>
                    </p>
                </div>
                <div class="col-6 p-0">
                    <p class="service-location-mobile text-start fs-12 m-0">Calibrations</p>
                    <p class="service-service-required-mobile text-start fw-b">
                      <i class="fa-solid fa-circle" :class="getServiceStatus(item)"></i>
                    </p>
                </div>
                <div class="col-6 p-0">
                    <p class="service-location-mobile text-start fs-12 m-0">Post Scan</p>
                    <p class="service-service-completed-mobile text-start fw-b">
                      <i class="fa-solid fa-circle" :class="getServiceStatus(item)"></i>
                    </p>
                </div>
                <div class="col-12 p-0"> 
                    <p class="service-location-mobile text-start fs-12 m-0">Drive Cycle / ADAS Validation</p>
                    <p class="service-service-completed-mobile text-start fw-b">
                      <i class="fa-solid fa-circle" :class="getServiceStatus(item)"></i>
                    </p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div v-if="cardData === 'noData'">
          <Loader singleEmptyCard="true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import ZFilterHeader from '@/components/utilities/elements/FilterHeader.vue'
import ZTableHeader from '@/components/utilities/elements/TableHeader.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
import ShopServiceSummary from '@/components/dashboard/shop/Shop_ServiceSummary.vue'
import ZHeader from '@/components/utilities/elements/TableHeader.vue'
import { authStore } from '@/stores/auth'
import moment from 'moment'
import Loader from '@/components/utilities/elements/Loader.vue'
export default {
  name: 'ServiceDetails',
  components: {
    ZFilterHeader,
    ZTableHeader,
    ZTable,
    ShopServiceSummary,
    ZHeader,
    Loader
  },
  data() {
    return {
      headerProps: {
        pageSizes: [
          { name: '10', value: 10 },
          { name: '25', value: 25 },
          { name: '50', value: 50 },
          { name: '100', value: 100 }
        ],
        title: null,
        subtitle: null,
        isTitle: false,
        isPaginated: true,
        isChecked: false,
        isAdd: false,
        isDelete: false,
        toggleButtons: null,
        buttons: null
      },
      tableHeader: [
        { field: 'adasInspection', label: '', sortable: false, class: 'custom-column-60-center' },
        { field: 'adasInspection', label: '#', sortable: true },
        { field: 'ronumber', label: 'RO#', sortable: true },
        { field: 'vin', label: 'VIN, Year/Make/Model', sortable: true },
        { field: 'deliveryDate', label: 'Delivered', sortable: true },
        { field: 'numberSystems', label: '# ADAS Systems', sortable: true },
        { field: 'numberServices', label: '# Required', sortable: true },
        { field: 'prescan', label: 'Pre-Scan', sortable: false },
        { field: 'inprogress', label: 'In Progress', sortable: false },
        { field: 'calibrations', label: 'Calibrations', sortable: false },
        { field: 'postscan', label: 'Post-Scan', sortable: false },
        { field: 'validation', label: 'Validation', sortable: false }
      ],
      currentParams: {
        numItems: 0,
        page: 1,
        pageSize: 10,
        filterBy: null,
        searchTerm: '',
        orderBy: 'adasInspection',
        sortBy: 'asc'
      }
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(dashboardStore, ['inspectionData', 'startDate', 'endDate', 'isRefresh']),
    ...mapState(authStore, ['profile']),
    tableData() {
      let _data = null
      if (this.inspectionData) {
        if (this.inspectionData !== 'noData') {
          _data = this.inspectionData.items
          console.log(_data)
        } else {
          _data = this.inspectionData
        }
      }
      return _data
    },
    cardData() {
      let _data = null
      if (this.inspectionData) {
        if (this.inspectionData !== 'noData') {
          _data = this.inspectionData.items
          console.log(_data)
        } else {
          _data = this.inspectionData
        }
      }
      return _data
    },
    tableCount() {
      let _data = null
      if (this.inspectionData) {
        _data = this.inspectionData.count
        this.updateParams({
          name: 'count',
          value: this.inspectionData.count
        })
      }
      return _data
    },
    dashboardDateRange() {
      return {
        startDate: this.startDate,
        endDate: this.endDate
      }
    },
    firmId() {
      let _data = null
      if (this.profile !== undefined && this.profile !== null) {
        _data = this.profile.firm
      }
      return _data
    },
    firmName() {
      let _data = null
      if (this.profile !== undefined && this.profile !== null) {
        _data = this.profile.firmName
      }
      return _data
    },
    source() {
      let _data = null
      if (this.firm) {
        _data = this.firm.source
      }
      return _data
    }
  },
  methods: {
    ...mapActions(dashboardStore, [
      'getLocationInspections',
      'getServicesBreakdown',
      'setDate',
      'sortArray',
      'setRefresh'
    ]),
    async init() {
      await this.fetchServicesBreakdown()
      await this.fetchInspections()
    },
    async fetchInspections() {
      let data = {
        firm: this.profile.firm,
        //firm:'48',
        startDate: this.startDate,
        endDate: this.endDate,
        search: this.currentParams.searchTerm,
        page: parseInt(this.currentParams.page) - 1,
        pageSize: this.currentParams.pageSize,
        orderBy: this.currentParams.orderBy,
        sortBy: this.currentParams.sortBy
      }
      await this.getLocationInspections(data)
      this.updateParams({
        name: 'count',
        value: this.inspectionData.count
      })
    },
    async fetchServicesBreakdown() {
      let data = {
        firm: this.profile.firm,
        //firm:'48',
        startDate: this.startDate,
        endDate: this.endDate,
        source: this.source
      }
      await this.getServicesBreakdown(data)
    },
    updateParams(data) {
      switch (data.name) {
        case 'page':
          this.currentParams.page = data.value
          break
        case 'count':
          this.currentParams.numItems = data.value
          break
      }
    },
    datesChanged(data) {
      this.setDate(data.name, data.value)
    },
    async refresh(forceRefresh) {
      if (forceRefresh) {
        this.currentParams.page = 1
        this.setRefresh(true)
      }
      if (this.isRefresh) {
        await this.fetchServicesBreakdown()
        await this.fetchInspections()
        this.setRefresh(false)
      }
    },
    search(data) {
      if (data.reset) {
        this.updateParams({
          name: 'page',
          value: 1
        })
      }
      console.log('Searching...', {
        data: data,
        currentParams: this.currentParams
      })
      this.fetchInspections()
    },
    formatDate(data) {
      let result = null
      if (data) {
        result = moment(data).format('MM/DD/YYYY')
      }
      return result
    },
    setVehicle(data) {
      return `${data.year} ${data.make} ${data.model}`
    },
    viewRecord(data) {
      router.push(`/vehicle-details/${data.vin}/${data.adasInspection}/location`)
    },
    getServiceStatus() {
      let rndClass = null
      let min = 1
      let max = 4
      let rndInt = Math.floor(Math.random() * (max + 1 - min) + min)
      switch (rndInt) {
        case 1:
          rndClass = 'custom-color-green'
          break
        case 2:
          rndClass = 'custom-color-red'
          break
        case 3:
          rndClass = 'custom-color-yellow'
          break
        case 4:
          rndClass = 'custom-color-grey'
          break
      }
      return rndClass
    },
    sortColumn(data, sortBy) {
      let result = this.sortArray(this.inspectionData.items, data.field, sortBy)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-vehicle {
  width: 100%;
  display: grid;
}
.custom-vehicle-info {
  font-size: 0.8em;
}
.custom-view-link {
  cursor: pointer;
}
.custom-color-codes {
  float: right;
  padding-right: 15px;
}
.custom-color-green {
  color: green;
}
.custom-color-red {
  color: red;
}
.custom-color-yellow {
  color: yellow;
}
.custom-color-grey {
  color: grey;
}
.dashboard-shop-card {
  max-height: 560px;
  overflow: auto;
}

.shop-list-container:nth-child(even) {
  background-color: #fcfcfd;
}

.shop-list-div:hover {
  background-color: rgb(97 169 36 / 10%);
  cursor: pointer;
}
.shop-list-div {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 10px;
}
.shop-header-mobile {
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.router-image-btn.collapsed .sd-collapse {
  display: none;
}

.router-image-btn .sd-collapse {
  display: block;
}
.router-image-btn.collapsed .sd-expand {
  display: block;
}
.router-image-btn .sd-expand {
  display: none;
}
</style>
